module.exports = __webpack_public_path__ + "static/media/avatar.b769f8fb.svg";